import { gsap, ScrollTrigger } from 'gsap/all'
import { rotateSplitTitle } from '../animations/rotateSplitTitle'
import { fadeInUp } from './fade-in-up'
gsap.registerPlugin(ScrollTrigger)

export function archive(element: HTMLElement) {
  const title = [...Array.from(element.querySelectorAll('.js-title'))] as HTMLElement[]
  const button = element.querySelector('.js-filters') as HTMLElement
  const cards = [...Array.from(element.querySelectorAll('.js-card'))] as HTMLElement[]
  const titleObject = title.map(title => rotateSplitTitle(title))
  const keyline = element.querySelector('.js-keyline svg polygon') as SVGPathElement

  if (keyline) {
    gsap.to(keyline, { drawSVG: '100%', duration: 1.8, ease: 'expo.out', delay: 0.35, autoAlpha: 1 })
  }

  let mm = gsap.matchMedia()

  // mm.add('(min-width: 992px)', () => {
  //   if (button) fadeInUp(button, 'top center', 'top+=25% center', false)
  // })

  // mm.add('(min-width: 769px)', () => {
  gsap.set(cards, { yPercent: 25, opacity: 0 })
  gsap.set(keyline, { drawSVG: '0%', autoAlpha: 0 })

  if (title) {
    gsap.to(title, { autoAlpha: 1 })
    titleObject.forEach((title, i) => {
      gsap.to(title.chars, {
        delay: i * 0.4,
        ease: 'power1.inOut',
        opacity: 1,
        rotationX: 0,
        autoAlpha: 1,
        yPercent: 0,
        stagger: {
          each: 0.03,
          from: 0
        }
      })
    })
  }
  //fix overlay to element using scriolltrigger

  cards.forEach((card, index) => {
    gsap.to(card, {
      yPercent: 0,
      opacity: 1,
      ease: 'expo.out',
      duration: 1.2,
      scrollTrigger: {
        trigger: card,
        start: 'top bottom',
        //   end: 'bottom 80%',
        invalidateOnRefresh: true
        // markers: true
      }
    })
  })
  //  })

}
